module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/core-js/object/define-properties.js
// module id = 1122
// module chunks = 168707334958949